import { render, staticRenderFns } from "./ActionDefault.vue?vue&type=template&id=2cd281aa&scoped=true&"
import script from "./ActionDefault.vue?vue&type=script&lang=js&"
export * from "./ActionDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd281aa",
  null
  
)

export default component.exports